import { render, staticRenderFns } from "./SyncLayoutToggle.vue?vue&type=template&id=aa3182ca&scoped=true"
import script from "./SyncLayoutToggle.vue?vue&type=script&lang=js"
export * from "./SyncLayoutToggle.vue?vue&type=script&lang=js"
import style0 from "./SyncLayoutToggle.vue?vue&type=style&index=0&id=aa3182ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3182ca",
  null
  
)

export default component.exports